import { render, staticRenderFns } from "./Carpentry.vue?vue&type=template&id=627ec757&"
import script from "./Carpentry.vue?vue&type=script&lang=js&"
export * from "./Carpentry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports